import React, { useRef, useState } from "react";
import { FaPause, FaPlay } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import heroVideo from "../Assets/videos/Header-bg.mp4";

const HeroHeader = () => {
  const videoRef = useRef(null);
  const navigate = useNavigate();
  const [isPaused, setIsPaused] = useState(false);
  
  // Search state
  const [searchParams, setSearchParams] = useState({
    erp: "",
    module: "",
    industry: "",
    experience: ""
  });
  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState(null);
  const [showResults, setShowResults] = useState(false);
  const [error, setError] = useState(null);

  const handleVideoToggle = () => {
    if (!videoRef.current) return;
    isPaused ? videoRef.current.play() : videoRef.current.pause();
    setIsPaused(!isPaused);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchParams(prev => ({
      ...prev,
      [name]: value
    }));
    setError(null);
  };

  const handleSearch = async () => {
    console.log("Search button clicked with:", searchParams);
    
    try {
      setIsSearching(true);
      setError(null);
      
      const params = new URLSearchParams();
      if (searchParams.erp) params.append('erp', searchParams.erp);
      if (searchParams.module) params.append('module', searchParams.module);
      if (searchParams.industry) params.append('industry', searchParams.industry);
      if (searchParams.experience) params.append('experience', searchParams.experience);
      
      console.log("Calling API with params:", params.toString());
      
      const response = await axios.get(`/api/seller/search?${params.toString()}`);
      console.log("API response:", response.data);
      
      setSearchResults(response.data);
      setShowResults(true);
      
    } catch (error) {
      console.error("Search failed:", error);
      setError(`Search failed: ${error.message}`);
      setSearchResults({
        success: false,
        message: "Search error",
        sellers: []
      });
      setShowResults(true);
    } finally {
      setIsSearching(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleViewProfile = () => {
    // Check if user is logged in
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    
    if (!token || !user) {
      // Not logged in - redirect to register
      console.log("User not logged in, redirecting to /register");
      window.location.href = "/register";
    } else {
      // Logged in - redirect to buyer dashboard
      console.log("User logged in, redirecting to /buyer/dashboard");
      window.location.href = "/buyer/dashboard";
    }
  };

  const closeModal = () => {
    setShowResults(false);
    setSearchResults(null);
  };

  const industryOptions = [
    "Aerospace & Defense",
    "Agriculture",
    "Architecture, Engineering & Construction (AEC)",
    "Automotive",
    "Banking & Financial Services",
    "Biotechnology",
    "Consumer Goods",
    "Education",
    "Healthcare",
    "Hospitality",
    "Information Technology (IT)",
    "Manufacturing",
    "Oil & Gas",
    "Retail",
    "Telecommunications",
    "Transportation",
    "Utilities",
  ];

  return (
    <header className="relative w-full min-h-screen overflow-hidden">
      <video
        ref={videoRef}
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={heroVideo} type="video/mp4" />
      </video>

      <div className="absolute inset-0 bg-black/60 z-10" />

      <div className="relative z-20 min-h-screen flex flex-col items-center justify-center px-4 pt-24 sm:pt-28 text-white">
        <h1 className="text-center text-4xl sm:text-5xl lg:text-6xl xl:text-7xl mb-10">
          Your first meeting with <br />
          ERP Consultant starts Here!
        </h1>

        {/* Error message */}
        {error && (
          <div className="mb-4 p-3 bg-red-500/80 text-white rounded-lg">
            {error}
          </div>
        )}

        {/* FILTER CONTAINER */}
        <div className="w-full max-w-7xl mx-auto bg-black/40 border-4 border-[#FFA500] rounded-xl shadow-2xl p-6 sm:p-8 mt-14 sm:mt-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 items-end">
            
            {/* ERP */}
            <div>
              <label className="block text-center font-semibold mb-2">
                Select ERP
              </label>
              <input
                name="erp"
                list="erp-options"
                placeholder="Choose ERP System"
                className="w-full px-4 py-3 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#4ACC8F]"
                value={searchParams.erp}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
              />
             <datalist id="erp-options">
    <option value="Acumatica" />
    <option value="eBridge Italian ERP" />
    <option value="Dynamic 365 Business Central" />
    <option value="Epicor Eclipse ERP" />
    <option value="Epicor Prophet21" />
    <option value="ERPNext" />
    <option value="Focus ERP" />
    <option value="Infor" />
    <option value="JD Edwards EnterpriseOne" />
    <option value="Microsoft Dynamics" />
    <option value="Microsoft Dynamics 365" />
    <option value="MS Navision" />
    <option value="Odoo" />
    <option value="Oracle" />
    <option value="Oracle Cloud EPM" />
    <option value="Oracle ERP Cloud" />
    <option value="Oracle Financials" />
    <option value="Oracle Fusion ERP" />
    <option value="Oracle NetSuite" />
    <option value="QAD" />
    <option value="QuickBooks Enterprise" />
    <option value="Sage 100 ERP" />
    <option value="Sage 200 ERP" />
    <option value="Sage 300cloud" />
    <option value="Sage 500" />
    <option value="Sage Intact" />
    <option value="Sage SDMO" />
    <option value="Sage X3" />
    <option value="Salesforce" />
    <option value="SAP" />
    <option value="SAP Business ByDesign" />
    <option value="SAP Business One" />
    <option value="SAP ECC6" />
    <option value="SAP S/4HANA" />
    <option value="SAP Signavio" />
    <option value="SORBA Construction ERP (SWISS)" />
    <option value="Swiss21 ERP" />
    <option value="Telly" />
    <option value="Workday Enterprise" />
    <option value="Workday Financial Management" />
    <option value="Yellow Jersey ERP" />
    <option value="Zoho ERP" />
    <option value="ZugaCloud Mexican ERP" />
</datalist>
            </div>

            {/* Module */}
            <div>
              <label className="block text-center font-semibold mb-2">
                Select Module
              </label>
              <input
                name="module"
                list="module-options"
                placeholder="Choose Module"
                className="w-full px-4 py-3 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#4ACC8F]"
                value={searchParams.module}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
              />
              <datalist id="module-options">
                <option value="Finance" />
                <option value="Human Resources" />
                <option value="Inventory" />
                <option value="Sales" />
                <option value="Procurement" />
                <option value="Manufacturing" />
                <option value="CRM" />
                <option value="SCM" />
              </datalist>
            </div>

            {/* Industry */}
            <div className="lg:col-span-1">
              <label className="block text-center font-semibold mb-2">
                Select Industry
              </label>
              <input
                name="industry"
                list="industry-options"
                placeholder="Choose Industry"
                className="w-full px-4 py-3 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#4ACC8F]"
                value={searchParams.industry}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
              />
              <datalist id="industry-options">
                {industryOptions.map((industry, index) => (
                  <option key={index} value={industry} />
                ))}
              </datalist>
            </div>

            {/* Experience */}
            <div>
              <label className="block text-center font-semibold mb-2">
                Consultant Experience
              </label>
              <input
                name="experience"
                list="experience-options"
                placeholder="Experience Level"
                className="w-full px-4 py-3 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#4ACC8F]"
                value={searchParams.experience}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
              />
              <datalist id="experience-options">
                <option value="0–1 Year" />
                <option value="2–4 Years" />
                <option value="5-10 Years" />
                <option value="10+ Years" />
              </datalist>
            </div>

            {/* BUTTON */}
            <div className="flex justify-center">
              <button
                onClick={handleSearch}
                disabled={isSearching}
                className="
                  w-full
                  h-[52px]
                  bg-[#FFA500]
                  hover:bg-[#cc8400]
                  disabled:bg-gray-400
                  disabled:cursor-not-allowed
                  text-white
                  font-semibold
                  rounded-lg
                  px-6
                  whitespace-nowrap
                  transition
                  flex items-center justify-center gap-2
                "
              >
                {isSearching ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                    Searching...
                  </>
                ) : (
                  "Find Consultants"
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Search Results Modal - SHOW ALL RESULTS */}
        {showResults && (
          <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden">
              <div className="bg-[#FFA500] p-4 flex justify-between items-center">
                <h2 className="text-xl font-bold text-white">
                  {searchResults?.success ? searchResults.message : "Search Results"}
                </h2>
                <button onClick={closeModal} className="text-white text-2xl hover:text-gray-200">
                  ×
                </button>
              </div>
              
              <div className="p-6 overflow-y-auto max-h-[70vh]">
                {isSearching ? (
                  <div className="flex justify-center items-center h-40">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#FFA500]"></div>
                  </div>
                ) : searchResults?.sellers && searchResults.sellers.length > 0 ? (
                  <div>
                    <p className="text-gray-600 mb-6">
                      Found {searchResults.count} consultant(s) matching your criteria
                    </p>
                    
                    {/* Seller List - SHOW ALL, not limited */}
                    <div className="space-y-4">
                      {searchResults.sellers.map((seller, index) => (
                        <div 
                          key={seller._id || index} 
                          className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors"
                        >
                          <div className="flex items-start gap-4">
                            {/* Profile Image */}
                            <div className="flex-shrink-0">
                              {seller.profileImage ? (
                                <img
                                  src={seller.profileImage && seller.profileImage.startsWith('/') 
                                    ? `/api${seller.profileImage}` 
                                    : seller.profileImage?.startsWith('http')
                                      ? seller.profileImage
                                      : `/api/uploads/${seller.profileImage}`}
                                  alt={seller.username || "Consultant"}
                                  className="w-16 h-16 rounded-full object-cover"
                                  onError={(e) => {
                                    e.target.src = "https://via.placeholder.com/64?text=Consultant";
                                  }}
                                />
                              ) : (
                                <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center">
                                  <span className="text-gray-600 font-bold text-lg">
                                    {(seller.username || "Consultant").charAt(0)}
                                  </span>
                                </div>
                              )}
                            </div>
                            
                            {/* Seller Info */}
                            <div className="flex-1">
                              <div className="flex items-center gap-2">
                                <h3 className="font-bold text-lg text-gray-800">
                                  {seller.username || "Consultant"}
                                </h3>
                                {seller.level && (
                                  <span className="text-sm bg-blue-100 text-blue-800 px-2 py-1 rounded">
                                    {seller.level}
                                  </span>
                                )}
                              </div>
                              
                              <p className="text-gray-600 mt-1">{seller.tagline || "ERP Consultant"}</p>
                              
                              <div className="flex flex-wrap gap-2 mt-2">
                                {seller.rating && (
                                  <span className="text-yellow-500 flex items-center">
                                    ★ {seller.rating} ({seller.reviewCount || 0} reviews)
                                  </span>
                                )}
                                {seller.location && (
                                  <span className="text-gray-500">📍 {seller.location}</span>
                                )}
                              </div>
                              
                              {seller.professionalSummary && (
                                <p className="text-gray-700 mt-2">
                                  {seller.professionalSummary}
                                </p>
                              )}
                              
                              {seller.technicalSkills && seller.technicalSkills.length > 0 && (
                                <div className="flex flex-wrap gap-1 mt-2">
                                  {seller.technicalSkills.map((skill, idx) => (
                                    <span key={idx} className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-sm">
                                      {skill}
                                    </span>
                                  ))}
                                </div>
                              )}
                            </div>
                            
                            {/* View Profile Button - with login check */}
                            <div className="flex-shrink-0">
                              <button 
                                onClick={handleViewProfile}
                                className="bg-[#FFA500] hover:bg-[#cc8400] text-white px-4 py-2 rounded-lg transition-colors"
                              >
                                View Profile
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-10">
                    <div className="text-gray-400 text-6xl mb-4">🔍</div>
                    <h3 className="text-xl font-semibold text-gray-700 mb-2">
                      No Consultants Found
                    </h3>
                    <p className="text-gray-500 mb-6">
                      {searchResults?.message || "We couldn't find any consultants matching your search criteria."}
                    </p>
                    <div className="space-y-2 text-left max-w-md mx-auto bg-gray-50 p-4 rounded-lg">
                      <p className="text-gray-600">Try:</p>
                      <ul className="list-disc list-inside text-gray-600 ml-2">
                        <li>Broadening your search criteria</li>
                        <li>Using different keywords</li>
                        <li>Searching for a specific ERP system</li>
                        <li>Checking spelling</li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
              
              {/* Footer - Only Close button, no View All */}
              <div className="border-t p-4">
                <button
                  onClick={closeModal}
                  className="w-full py-3 bg-gray-800 hover:bg-gray-900 text-white rounded-lg font-medium transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Mobile Video Control */}
        <div className="fixed bottom-4 right-4 z-30 md:hidden">
          <button
            onClick={handleVideoToggle}
            className="p-3 bg-black/50 rounded-full"
            aria-label={isPaused ? "Play video" : "Pause video"}
          >
            {isPaused ? <FaPlay size={20} /> : <FaPause size={20} />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default HeroHeader;
